import {
  FormDialog,
  FormItem,
  FormLayout,
  Input,
  Password,
} from "@formily/antd";
import { createSchemaField } from "@formily/react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const SchemaField = createSchemaField({
  components: {
    FormItem,
    Input,
    Password,
  },
});

const schema = {
  type: "object",
  properties: {
    office_phone: {
      type: "string",
      title: "办公室电话",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input",
      "x-component-props": {
        placeholder: "请输入办公室电话",
      },
    },
    director_name: {
      type: "string",
      title: "负责人",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input",
      "x-component-props": {
        placeholder: "请输入负责人姓名",
      },
    },
    director_job: {
      type: "string",
      title: "负责人职位",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input",
      "x-component-props": {
        placeholder: "请输入负责人职位",
      },
    },
    director_phone: {
      type: "string",
      title: "负责人电话",
      required: true,
      format: "phone",
      "x-decorator": "FormItem",
      "x-component": "Input",
      "x-component-props": {
        placeholder: "请输入负责人电话",
      },
    },
    name: {
      type: "string",
      title: "联系人",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input",
      "x-component-props": {
        placeholder: "请输入联系人姓名",
      },
    },
    job: {
      type: "string",
      title: "职位",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input",
      "x-component-props": {
        placeholder: "请输入联系人职位",
      },
    },
    phone: {
      type: "string",
      title: "电话",
      required: true,
      format: "phone",
      "x-decorator": "FormItem",
      "x-component": "Input",
      "x-component-props": {
        placeholder: "请输入联系人电话",
      },
    },
    password: {
      type: "string",
      title: "密码",
      required: true,
      format: "password",
      "x-decorator": "FormItem",
      "x-component": "Password",
      "x-component-props": {
        checkStrength: true,
      },
      "x-reactions": [
        {
          dependencies: [".confirm_password"],
          fulfill: {
            state: {
              selfErrors:
                '{{$deps[0] && $self.value && $self.value !== $deps[0] ? "确认密码不匹配" : ""}}',
            },
          },
        },
      ],
    },
    confirm_password: {
      type: "string",
      title: "确认密码",
      required: true,
      format: "password",
      "x-decorator": "FormItem",
      "x-component": "Password",
      "x-component-props": {
        checkStrength: true,
      },
      "x-reactions": [
        {
          dependencies: [".password"],
          fulfill: {
            state: {
              selfErrors:
                '{{$deps[0] && $self.value && $self.value !== $deps[0] ? "确认密码不匹配" : ""}}',
            },
          },
        },
      ],
    },
  },
};

function ProfileSetting() {
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <span
      onClick={() => {
        FormDialog("账号设置", () => {
          return (
            <FormLayout labelCol={6} wrapperCol={18}>
              <SchemaField schema={schema} />
            </FormLayout>
          );
        })
          .forConfirm((payload, next) => {
            (async () => {
              const url = await dispatch.user.updateProfile(payload.values);
              if (url) {
                next(payload);
              }
            })();
          })
          .open({
            initialValues: {
              office_phone: user.office_phone,
              name: user.name,
              job: user.job,
              phone: user.phone,
              director_name: user.director_name,
              director_job: user.director_job,
              director_phone: user.director_phone,
            },
          })
          .then(console.log);
      }}
    >
      设置
    </span>
  );
}

export default ProfileSetting;
